import {
    StyledChip,
    StyledFilterContainer,
    StyledInlineContainer,
    StyledInlineDiv, StyledJsonPreview,
    StyledSpaceBetweenDiv
} from '@/components/common/CustomStyledComponents'
import {Grid, Typography } from '@mui/material'
import {LockPerson, Public} from '@mui/icons-material'
import React from 'react'
import {DatabaseInfo} from '@/generated/graphql'
import {omitDeep} from '@apollo/client/utilities'

type DatabaseDetailContentProps = {
    database?: DatabaseInfo
}

const DatabaseDetailContent = ({database}: DatabaseDetailContentProps) => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid size={8}>
                    <StyledSpaceBetweenDiv>
                        <Typography fontWeight="bolder">Name: {database?.database_name}</Typography>
                        <StyledChip icon={database?.public ? <Public/> : <LockPerson/>}
                            label={database?.public ? 'PUBLIC' : 'PRIVATE'}/>
                    </StyledSpaceBetweenDiv>
                    <StyledInlineContainer>
                        <StyledInlineDiv>
                            <Typography fontWeight="bolder">Version:</Typography>
                            <Typography>{database?.version}</Typography>
                        </StyledInlineDiv>
                        <StyledInlineDiv>
                            <Typography fontWeight="bolder">Variant count:</Typography>
                            <Typography>{database?.variant_count}</Typography>
                        </StyledInlineDiv>
                        <StyledInlineDiv>
                            <Typography fontWeight="bolder">Reference genome:</Typography>
                            <Typography>{database?.reference_genome}</Typography>
                        </StyledInlineDiv>
                    </StyledInlineContainer>
                    <StyledInlineContainer>
                        <Typography fontWeight="bolder">Description:</Typography>
                    </StyledInlineContainer>
                    <StyledInlineContainer>
                        <Typography>{database?.description}</Typography>
                    </StyledInlineContainer>
                </Grid>
                <Grid size={4}>
                    <StyledFilterContainer>
                        <Typography variant='h5'>Filter options</Typography>
                        {database?.filter_options &&
                            <StyledJsonPreview>{JSON.stringify(omitDeep(database.filter_options, '__typename'), null, 1)}</StyledJsonPreview>}
                    </StyledFilterContainer>
                </Grid>
            </Grid>
        </>
    )
}

export default DatabaseDetailContent